/**
 * API base URL. Resolved at runtime so local dev always uses port 8003
 * when opening admin from localhost (avoids Docker build-arg issues).
 */
export const getApiUrl = () => {
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  if (isLocalhost) {
    return 'http://localhost:8003/api';
  }
  return process.env.REACT_APP_API_URL || 'https://api.apartament340.pl/api';
};

export const API_URL = getApiUrl();
